
import React from 'react'
import usePageTitle from '../../hooks/usePageTitle'
import PaidCampaigns from './PaidCampaigns'
import BarterCampaigns from './BarterCampaigns'
import ProCampaigns from './ProCampaigns'
import EarlyAccessCampaigns from './EarlyAccessCampaigns'
import AllCampaigns from './AllCampaigns'
import InvitedCampaignsV2 from '../campaign/InvitedCampaignsV2'

const AllSponsorships = () => {
    usePageTitle('Sponsorships')

    return (
        <div className="mt-3 d-flex flex-column gap-4">
            <InvitedCampaignsV2 />
            <PaidCampaigns />
            <BarterCampaigns />
            {/* <ProCampaigns /> */}
            {/* <EarlyAccessCampaigns /> */}
            <AllCampaigns />
        </div>
    )
}

export default AllSponsorships